<template>
  <div id="app">
    <NavBar :idx="idx" @changIdx="change" />
    <router-view @changIdx="change"></router-view>
    <FotterBar @changIdx="change" />
    <transition name="fade">
      <div v-show="showFixed" class="fixed_call" @click="goCall">
        <img src="@/assets/img/fixed.png" alt="" />
        <i class="el-icon-phone-outline">联系我们</i>
      </div>
    </transition>
  </div>
</template>
<script>
import NavBar from "./views/Nav/NavBar.vue";
import FotterBar from "./views/Footer/FotterBar.vue";
export default {
  name: "app",
  components: {
    NavBar,
    FotterBar,
  },
  data() {
    return {
      idx: 0,
      showFixed: true,
      time: null,
    };
  },
  methods: {
    change(idx) {
      this.idx = idx;
    },
    goCall() {
      if (this.$route.path == "/call") {
        location.reload();
        window.scrollTo(0, 0);
        return;
      }
      this.idx = 5;
      window.localStorage.setItem("activeIndex", this.idx);
      this.$router.push("/call");
    },
  },
  mounted() {
    clearInterval(this.time);
    this.time = setInterval(() => {
      this.showFixed = !this.showFixed;
    }, 8000);
  },
};
</script>
<style lang="less">
#app {
  width: 100%;
  height: 100%;
  background-color: #f5f5f5;
  .fixed_call {
    cursor: pointer;
    width: 100px;
    height: 100px;
    position: fixed;
    right: 0;
    bottom: 100px;
    img {
      width: 100%;
    }
    i {
      position: absolute;
      left: 0;
      bottom: 7px;
      padding-left: 7px;
    }
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
